module.exports = __webpack_public_path__ + "static/img/startup.32a9b213.png";